import { useAppContext } from '@/context/AppContext';
import { CURRENT_USER } from '@/data/currentUser';
import type { CurrentUser } from '@/data/currentUser';

interface UseCurrentUserResult {
  data: CurrentUser | null;
  isLoading: boolean;
}

export function useCurrentUser(): UseCurrentUserResult {
  const { mockupMode, currentUser } = useAppContext();
  if (mockupMode) return { data: CURRENT_USER, isLoading: false };
  // In live mode, derive from AppContext (populated by ClerkSync)
  if (!currentUser.id) return { data: null, isLoading: true };
  return {
    data: {
      id: currentUser.id,
      name: currentUser.name,
      email: currentUser.email,
      role: currentUser.role,
      businessUnitId: '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      dateFormat: 'MMM D, YYYY',
    },
    isLoading: false,
  };
}
